import {formatCurrency} from "../../common/Utils";
import React, {useEffect, useState} from "react";
import {DesktopTimePicker, TimePicker} from "@mui/x-date-pickers";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import MDInput from "../../../components/MDInput";
import useMediaQuery from '@mui/material/useMediaQuery';
import {useTheme} from "@mui/material/styles";

export default function CafeGroups({inventory, quantity, callback, cafeCallback, groups}) {

  const [validationGroups, setValidationGroups] = useState([]);
  const [groupsReady, setGroupsReady] = useState(false);
  const [groupPrice, setGroupPrice] = useState(0);
  const [orderValid, setOrderValid] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    setValidationGroups([...groups]);
    setGroupsReady(true)
  }, []);

  useEffect(() => {
    let _validationGroups = [...validationGroups];
    let price = inventory.price;
    for (let k in _validationGroups) {
      for (let j in _validationGroups[k].options) {
        if (_validationGroups[k].options[j].selected && _validationGroups[k].options[j]?.price > 0) {
          price += _validationGroups[k].options[j].price;
        }
      }
    }
    setGroupPrice(price);
  }, [validationGroups]);

  useEffect(() => {
    let _validationGroups = [...validationGroups];
    let formValid = true;
    for (let k in _validationGroups) {
      if (_validationGroups[k].required) {
        let groupHasOption = false;
        for (let j in _validationGroups[k].options) {
          if (_validationGroups[k].options[j].scheduleDate && _validationGroups[k].options[j].scheduledAt) {
            groupHasOption = true;
          } else if (_validationGroups[k].options[j].selected) {
            groupHasOption = true;
          }
        }
        if (!groupHasOption) {
          formValid = false;
        }
      }
    }

    setOrderValid(formValid)

    cafeCallback({
      orderValid: formValid,
      cafeOptions: validationGroups
    })

  }, [validationGroups]);

  const toggleInstruction = (evt, option, group) => {
    let _validationGroups = [...validationGroups]
    for (let k in _validationGroups) {
      if (_validationGroups[k].optionGroupGk === group.optionGroupGk) {
        for (let j in _validationGroups[k].options) {
          if (_validationGroups[k].options[j].optionGk === option.optionGk) {
            _validationGroups[k].options[j].instructions = evt.target.value;
          }
        }
      }
    }
  }

  const toggleScheduleDate = (d, option, group) => {
    let _validationGroups = [...validationGroups]
    for (let k in _validationGroups) {
      if (_validationGroups[k].optionGroupGk === group.optionGroupGk) {
        for (let j in _validationGroups[k].options) {
          if (_validationGroups[k].options[j].optionGk === option.optionGk) {
            _validationGroups[k].options[j].scheduledAt = d?.$d;
          }
        }
      }
    }
    setValidationGroups(_validationGroups);
  }

  const toggleOption = (evt, option, group) => {
    option.selected = !!!option.selected;
    let _validationGroups = [...validationGroups]
    for (let k in _validationGroups) {
      if (_validationGroups[k].optionGroupGk === group.optionGroupGk) {
        for (let j in _validationGroups[k].options) {
          if (_validationGroups[k].options[j].optionGk === option.optionGk) {
            _validationGroups[k].options[j] = {...option}
          } else {
            if (group.single) {
              let _o = {..._validationGroups[k].options[j]};
              _o.selected = false;
              _validationGroups[k].options[j] = {..._o}
            }
          }
        }
      }
    }
    setValidationGroups(_validationGroups);
  }

  const optionSelected = (option, group) => {
    for (let k in validationGroups) {
      if (validationGroups[k].optionGroupGk === group.optionGroupGk) {
        for (let j in validationGroups[k].options) {
          if (validationGroups[k].options[j].optionGk === option.optionGk) {
            let isSelected = option.selected;
            if (isSelected) {
              return isSelected;
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <div>
      {groupsReady && groups?.length > 0 &&

        <div>
          <h5>{formatCurrency(groupPrice)}</h5>
          {quantity > 1 && <h6>Total: {formatCurrency(groupPrice * quantity)}</h6>}

          {groups?.sort((a, b) => a.sortOrder - b.sortOrder).map((g, idx) => {
            return (
              <div key={idx}>
                <h6 className={'mt-2'}>{g.optionGroupName}{g.required ? <sup>*</sup> : ''}</h6>
                {g.single &&
                  <span>
                    {g.options?.sort((a, b) => a.sortOrder - b.sortOrder).map((o, idx) => {
                      return (
                        <span key={idx} style={{
                          display: 'inline-block',
                          width: '100%',
                          margin: '4px -2px',
                        }}>
                            <label key={idx} style={{
                              cursor: 'pointer'
                            }}><Checkbox key={idx}
                                         checked={optionSelected(o, g)}
                                         onChange={(e) => {
                                           toggleOption(e, o, g)
                                         }}
                            />
                              {o.optionName}
                              {o?.price > 0 &&
                                <span>&nbsp;(+{formatCurrency(o.price)})</span>}
                            </label>
                           </span>
                      )
                    })
                    }
                  </span>
                }

                {!g.single &&
                  <div>
                    {g.options.length <= 5 && <>
                      {g.options?.sort((a, b) => a.sortOrder - b.sortOrder).map((o, idx) => {
                        return (
                          <span key={idx}>
                            {o.specialInstructions && <>
                              <div className={'d-block my-2'}>
                                <MDInput
                                  label={o.optionName}
                                  onChange={(e) => {
                                    toggleInstruction(e, o, g)
                                  }}
                                  InputLabelProps={{shrink: true}}
                                  autoComplete="off"
                                  maxLength={255}
                                  className="form-control my-1"
                                  placeholder={o.optionName}/>
                              </div>
                            </>
                            }
                            {o.scheduleDate && <>
                              <div className={'d-block my-2'}>
                                <DesktopTimePicker
                                  className="form-control my-1"
                                  label={o.optionName}
                                  placeholder={o.optionName}
                                  slotProps={{
                                    textField: {
                                      InputLabelProps: {
                                        shrink: true,
                                      },

                                    },
                                  }}
                                  onChange={(d) => {
                                    toggleScheduleDate(d, o, g)
                                  }}
                                />
                              </div>
                            </>
                            }
                            {!o.specialInstructions && !o.scheduleDate && <>
                              <span key={idx} style={{
                                display: 'inline-block',
                                width: '100%',
                                margin: '4px -2px',
                              }}>
                            <label key={idx} style={{
                              cursor: 'pointer'
                            }}><Checkbox key={idx}
                                         checked={optionSelected(o, g)}
                                         onChange={(e) => {
                                           toggleOption(e, o, g)
                                         }}
                            />
                              {o.optionName}
                              {o?.price > 0 &&
                                <span>&nbsp;(+{formatCurrency(o.price)})</span>}
                            </label>
                           </span>
                            </>
                            }
                          </span>
                        )
                      })
                      }
                    </>
                    }


                    {g.options.length > 5 && <>
                      {g.options?.sort((a, b) => a.sortOrder - b.sortOrder).map((o, idx) => {
                        return (
                          <span key={idx}>
                            {o.specialInstructions && <>
                              <MDInput
                                label={'Instructions'}
                                onChange={(e) => {

                                }}
                                InputLabelProps={{shrink: true}}
                                autoComplete="off"
                                maxLength={255}
                                className="form-control" id="desc"
                                placeholder={o.optionName}/>
                            </>}
                            {!o.specialInstructions && <>
                            <span key={idx} style={{
                              display: 'inline-block',
                              width: '100%',
                              margin: '4px -2px',
                            }}>
                            <label key={idx} style={{
                              cursor: 'pointer'
                            }}><Checkbox key={idx}
                                         checked={optionSelected(o, g)}
                                         onChange={(e) => {
                                           toggleOption(e, o, g)
                                         }}
                            />
                              {o.optionName}
                              {o?.price > 0 &&
                                <span>&nbsp;(+{formatCurrency(o.price)})</span>}
                            </label>
                           </span>
                            </>}
                          </span>
                        )
                      })
                      }
                    </>
                    }
                  </div>
                }
              </div>
            )
          })}

        </div>
      }
    </div>
  )
}